var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconawesomeExclamationTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 20,
    viewBox: "0 0 22.5 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exclamation-triangle",
    "data-name": "Icon awesome-exclamation-triangle",
    d: "M22.247,17.188A1.876,1.876,0,0,1,20.623,20H1.877A1.876,1.876,0,0,1,.253,17.188L9.626.937a1.876,1.876,0,0,1,3.248,0Zm-11-3.36a1.8,1.8,0,1,0,1.8,1.8A1.8,1.8,0,0,0,11.25,13.828ZM9.544,7.369l.29,5.312a.469.469,0,0,0,.468.443h1.9a.469.469,0,0,0,.468-.443l.29-5.312a.469.469,0,0,0-.468-.494H10.012a.469.469,0,0,0-.468.494Z",
    transform: "translate(0 0)",
    fill: "#a46666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeExclamationTriangle);
export default __webpack_public_path__ + "static/media/Icon awesome-exclamation-triangle.b09d3481976fc4ae79fa7baf0c008a6f.svg";
export { ForwardRef as ReactComponent };